module.exports = __webpack_public_path__ + "img/28.bec23793.png";